import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { semanticColors } from "../../Globals/styles";
import PeriodRow from "./periodRow";
import SuggestSelectInput from "../../Common/suggestSelectInput";

class SalaryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestSelectInputVal: { id: null, name: null },
    };
  }
  shouldComponentUpdate = (nextProps) => {
    //if there is no updateObject always update or if there is change is isSortedByEmplyoee is changed
    if (
      !nextProps.updateObject ||
      nextProps.isSortedByEmployee !== this.props.isSortedByEmployee
    )
      return true;

    //if its sorted by employee
    if (this.props.isSortedByEmployee) {
      if (nextProps.updateObject.employeeId === nextProps.headingId)
        return true;
      else if (nextProps.updateObject.secondObject) {
        if (
          nextProps.updateObject.secondObject.employeeId === nextProps.headingId
        )
          return true;
      }
    }
    //if its sorted by case
    else {
      return true;
    }
    return false;
  };
  renderPeriodRows = () => {
    const {
      startWeek,
      endWeek,
      periodIds,
      getPeriod,
      getProject,
      getEmployee,
      getDay,
      isSortedByEmployee,
      getEmployeeTotalSum,
      getEmployeeTotalSum2,
      openCalculator,
      setOpenCalculator,
      updateDay,
      updatePeriodInput,
      updateObject,
      conflictingProjects,
      getEmployeeTotalOvertTimeSum,
    } = this.props;
    return periodIds.map((periodId) => {
      return (
        <PeriodRow
          key={periodId}
          startWeek={startWeek}
          endWeek={endWeek}
          period={getPeriod(periodId)}
          getProject={getProject}
          getEmployee={getEmployee}
          getDay={getDay}
          isSortedByEmployee={isSortedByEmployee}
          getEmployeeTotalSum={getEmployeeTotalSum}
          getEmployeeTotalSum2={getEmployeeTotalSum2}
          getEmployeeTotalOvertTimeSum={getEmployeeTotalOvertTimeSum}
          openCalculator={openCalculator}
          setOpenCalculator={setOpenCalculator}
          updateDay={updateDay}
          updatePeriodInput={updatePeriodInput}
          updateObject={updateObject}
          conflictingProjects={conflictingProjects}
        />
      );
    });
  };
  getEmployeeHeader = () => {
    const {
      headingId,
      getEmployee,
      getEmployeeTotalSum,
      getEmployeeTotalSum2,
      getEmployeeTotalOvertTimeSum,
    } = this.props;
    let employee = getEmployee(headingId);
    const overtime = getEmployeeTotalOvertTimeSum(employee.id);
    return (
      <div style={styles.header}>
        <div style={styles.employeeHeader}>
          <h2 style={styles.h2}>{employee.id + " - " + employee.name}</h2>
          <div>
            Total antal timer: {getEmployeeTotalSum(employee.id)}{" "}
            <span>
              {" / "}
              <span>{getEmployeeTotalSum2(employee.id)}</span>
              {overtime > 0 ? (
                <span
                  style={{ color: semanticColors.danger, fontWeight: "bold" }}
                >
                  {" "}
                  Overtid: {overtime}
                </span>
              ) : null}
            </span>
          </div>
        </div>
      </div>
    );
  };
  onSuggestInputChange = (val) => {
    if (val.id) {
      this.setState({
        suggestSelectInputVal: { name: null, id: null },
      });
      this.props.attemtAddEmployeeToProject(val.id);
    } else {
      this.setState({
        suggestSelectInputVal: val,
      });
    }
  };
  getProjectHeader = () => {
    const {
      headingId,
      getProject,
      getEmployeeSuggestions,
      employeeSuggestions,
    } = this.props;
    let project = getProject(headingId);
    return (
      <div style={styles.header}>
        <h2 style={[styles.projectHeader, styles.h2]}>
          {project.number + " - " + project.name}
        </h2>
        <div style={styles.addEmployeeContainer}>
          <SuggestSelectInput
            onChange={this.onSuggestInputChange}
            onQuery={getEmployeeSuggestions}
            suggestions={employeeSuggestions}
            value={this.state.suggestSelectInputVal}
            placeholder="Tilføj medarbejder"
          />
        </div>
      </div>
    );
  };
  getFirstTableRowHeader = () => {
    const { isSortedByEmployee } = this.props;
    return isSortedByEmployee ? (
      <th style={styles.th}>Sag</th>
    ) : (
      [
        <th key="empNumber" style={styles.th}>
          Nr.
        </th>,
        <th key="empName" style={styles.th}>
          Medarbejder
        </th>,
      ]
    );
  };
  render() {
    const { isSortedByEmployee } = this.props;
    return (
      <div className="row" style={styles.container}>
        {isSortedByEmployee
          ? this.getEmployeeHeader()
          : this.getProjectHeader()}

        <table style={styles.table}>
          <thead>
            <tr>
              {this.getFirstTableRowHeader()}
              <th style={styles.th}>Uge</th>
              <th style={styles.th}>Man</th>
              <th style={styles.th}>Tirs</th>
              <th style={styles.th}>Ons</th>
              <th style={styles.th}>Tors</th>
              <th style={styles.th}>Fre</th>
              <th style={styles.th}>Lør</th>
              <th style={styles.th}>Søn</th>
              <th style={styles.th}>Sum</th>
              <th style={styles.th}>Sats</th>
              <th style={styles.th}>Tillæg</th>
              <th style={styles.th}>Kørep.</th>
              <th style={styles.th}>Skur</th>
              <th style={styles.th}>hensættes til afspad.</th>
              <th style={styles.th}>100%</th>
            </tr>
          </thead>

          {this.renderPeriodRows()}
        </table>
      </div>
    );
  }
}

var styles = {
  container: {
    padding: "0px 2px 14px 2px",
    backgroundColor: semanticColors.default,
    borderRadius: "2px",
    marginBottom: "20px",
  },
  header: {
    height: "75px",
    textAlign: "center",
    position: "relative",
  },
  table: {
    width: "100%",
  },
  th: {
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    height: "40px",
  },
  addEmployeeContainer: {
    position: "absolute",
    right: "0",
    top: "50%",
    marginTop: "-17.5px",
    width: "254px",
    padding: "0 12px",
  },
  projectHeader: {
    lineHeight: "75px",
  },
  employeeHeader: {
    width: "600px",
    height: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: "-300px",
    marginTop: "-20px",
  },
  h2: {
    fontSize: "16px",
  },
};
SalaryTable.propTypes = {
  startWeek: PropTypes.number.isRequired,
  endWeek: PropTypes.number.isRequired,
  periodIds: PropTypes.array.isRequired,
  getPeriod: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getProject: PropTypes.func.isRequired,
  getDay: PropTypes.func.isRequired,
  headingId: PropTypes.string.isRequired,
  isSortedByEmployee: PropTypes.bool.isRequired,
  getEmployeeTotalSum: PropTypes.func.isRequired,
  openCalculator: PropTypes.string.isRequired,
  setOpenCalculator: PropTypes.func.isRequired,
  updateDay: PropTypes.func.isRequired,
  updatePeriodInput: PropTypes.func.isRequired,
  updateObject: PropTypes.object,
  getEmployeeSuggestions: PropTypes.func,
  employeeSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  attemtAddEmployeeToProject: PropTypes.func,
  conflictingProjects: PropTypes.object.isRequired,
};

export default Radium(SalaryTable);



// WEBPACK FOOTER //
// ./src/App/Project/Salary/salaryTable.jsx